import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { routing, RootComponent } from './route';
import { FormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { indexComponent } from './component/index/index.component';
import { imageBatchComponent } from './component/imageBatch/imageBatchComponent';
import { historyListComponent } from './component/historyList/historyList.component';
import { shoppingOrderComponent } from './component/shoppingOrder/shoppingOrder';
import { containerNumberComponent } from './component/containerNumber/containerNumber';
import { sealNumberComponent } from './component/sealNumber/sealNumber';


//  Ai 解析数据 布局
import { identificationViewComponent } from './component/identificationView/identification';

// Ai 解析数据 对应单独的路由 
import { zhuangxiangdanComponent } from './component/identificationView/component/zhuangxiangdan/zhuangxiangdan';

import { identificationComponent } from './component/identification/identification';
import { identificationNewComponent } from './component/identificationNew/identification';
import { NZ_I18N, zh_CN, NgZorroAntdModule } from 'ng-zorro-antd';

import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';
registerLocaleData(zh);
import { customsDeclarationsComponent } from './component/customsDeclarations/customsDeclarations'

@NgModule({
  declarations: [
    AppComponent,
    indexComponent,
    imageBatchComponent,
    historyListComponent,
    RootComponent,
    shoppingOrderComponent,
    containerNumberComponent,
    sealNumberComponent,
    identificationViewComponent,
    zhuangxiangdanComponent,
    identificationComponent,
    identificationNewComponent,
    customsDeclarationsComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    routing,
    FormsModule,
    /** 导入 ng-zorro-antd 模块 **/
    NgZorroAntdModule.forRoot(),
    BrowserAnimationsModule,

  ],
  providers: [{ provide: NZ_I18N, useValue: zh_CN }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /srv/jenkins-test/workspace/dev-doc-web/src/app/app.module.ts